import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserDashboardHostComponent } from './user-dashboard-host/user-dashboard-host.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TranslateModule } from '@ngx-translate/core';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { AppCommonModule } from '../../components/common/app-common.module';
import { ProjectDetailsComponent } from './components/project-details/project-details.component';
import { UserTasksPaneComponent } from './components/user-tasks-pane/user-tasks-pane.component';
import { ApprovalMatrixComponent } from './components/approval-matrix/approval-matrix.component';
import { GeneralTasksApprovalMatrixComponent } from './components/general-tasks-approval-matrix/general-tasks-approval-matrix.component';
import { UserDashboardService } from './services/user-dahsboard.service';
import { ApprovalHistoryComponent } from './components/raci-approval-history/raci-approval-history.component';
import { ValoremPublishTaskComponent } from './components/valorem-publish-task/valorem-publish-task.component';
import { ArgusApprovalMatrixComponent } from './components/argus-approval-matrix/argus-approval-matrix.component';
import { ValoremApprovalMatrixComponent } from './components/valorem-approval-matrix/valorem-approval-matrix.component';
import { ArgusPushMatrixComponent } from './components/argus-push-matrix/argus-push-matrix.component';
import { ValoremIntegrationService } from './services/valorem-integration.service';
import { DataFromArgusDialogComponent } from './components/data-from-argus-dialog/data-from-argus-dialog.component';
import { NavigationModule } from '../../navigation/navigation.module';
import { CloseValuationEventComponent } from './components/close-valuation-event/close-valuation-event.component';
import { CloseValuationEventDialogComponent } from './components/close-valuation-event-dialog/close-valuation-event-dialog.component';
import { ValuationEventSetupFormComponent } from './components/valuation-event-setup-form/valuation-event-setup-form.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ValuationEffectiveDatesSetupComponent } from './components/valuation-effective-dates-setup/valuation-effective-dates-setup.component';
import { RaciApprovalDialogComponent } from '../raci/components/raci-approval-dialog/raci-approval-dialog.component';

/**
 * Routes
 */
export const routerModule = RouterModule.forChild([{
  path: 'overview',
  component: UserDashboardHostComponent
}]);

/**
 *User Dashboard module
 */
@NgModule({
  imports: [
    CommonModule,
    routerModule,
    GridModule,
    DropDownsModule,
    ReactiveFormsModule,
    ButtonsModule,
    TranslateModule,
    UploadsModule,
    FormsModule,
    LayoutModule,
    InputsModule,
    AppCommonModule,
    NavigationModule,
    DateInputsModule
  ],
  exports: [
    UserTasksPaneComponent,
    ApprovalMatrixComponent,
    GeneralTasksApprovalMatrixComponent,
    ApprovalHistoryComponent,
    ValoremApprovalMatrixComponent,
    ValoremPublishTaskComponent,
    ArgusApprovalMatrixComponent,
    ArgusPushMatrixComponent,
    DataFromArgusDialogComponent,
    CloseValuationEventComponent,
    CloseValuationEventDialogComponent,
    DataFromArgusDialogComponent,
    ValuationEventSetupFormComponent,
    ValuationEffectiveDatesSetupComponent,
    RaciApprovalDialogComponent
  ],
  declarations: [
    UserDashboardHostComponent,
    UserTasksPaneComponent,
    ApprovalMatrixComponent,
    GeneralTasksApprovalMatrixComponent,
    ProjectDetailsComponent,
    ApprovalHistoryComponent,
    ValoremPublishTaskComponent,
    ValoremApprovalMatrixComponent,
    ArgusApprovalMatrixComponent,
    ArgusPushMatrixComponent,
    DataFromArgusDialogComponent,
    CloseValuationEventComponent,
    CloseValuationEventDialogComponent,
    DataFromArgusDialogComponent,
    ValuationEventSetupFormComponent,
    ValuationEffectiveDatesSetupComponent,
    RaciApprovalDialogComponent
  ],
  providers: [
    UserDashboardService,
    ValoremIntegrationService
  ]
})
export class UserDashboardModule { }
